import { Cloud_API_URL } from "../utils/constants";

export const fetchScheduledTestsForUser = async (userId, testColorMapRef) => {
  try {
    // Construct the URL for fetching scheduled tests data based on the userId and optional start/end dates.
    let url = `${Cloud_API_URL}/scheduled_tests/${userId}/get-scheduled-tests`;

    // Fetch data from the constructed URL using the fetch API.
    const response = await fetch(url);
    const fetchedData = await response.json();
    const events =
      fetchedData.length > 0
        ? fetchedData.map((item, index) => {
            const scheduledDatetime = new Date(item.scheduled_datetime);
            const completionDatetime = item.completion_datetime
              ? new Date(item.completion_datetime)
              : null;
            const eventName = item.test.name;
            const isMandatory = item.is_mandatory;
            const noticePeriod = item.notice_period;
            const eventDescription = item.user.type;

            let startDatetime;
            let color;

            if (item.completion_datetime) {
              startDatetime = new Date(item.completion_datetime);
              color = "lime";
            } else {
              startDatetime = scheduledDatetime;
              color = testColorMapRef[item.test.id];
            }

            const endDatetime = new Date(startDatetime);
            endDatetime.setMinutes(startDatetime.getMinutes() + 15);
            return {
              id: item.id,
              title: eventName,
              scheduledStart: scheduledDatetime,
              start: startDatetime,
              isMandatory: isMandatory,
              noticePeriod: noticePeriod,
              end: endDatetime,
              completionDate: completionDatetime,
              desc: eventDescription,
              color: color,
            };
          })
        : [];

    return events;
  } catch (error) {
    console.error("Error:", error);
    return []; // Return an empty array in case of error
  }
};

export const deleteScheduledTestForUser = async (userId, testId) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_GATEWAY_CLOUDRUN}scheduled_tests/${userId}/scheduled-tests/${testId}`,
      {
        method: "DELETE",
      }
    );

    if (response.ok) {
      return true;
    } else {
      console.error("Error deleting test:", response.statusText);
      return false;
    }
  } catch (error) {
    console.error("Error deleting test:", error);
    return false;
  }
};

export const fetchTests = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_GATEWAY_CLOUDRUN}scheduled_tests/getTests`
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching tests:", error);
    return [];
  }
};

export const createOrUpdateScheduledTest = async (
  userId,
  editId,
  tests,
  testType,
  scheduledDate,
  isMandatory,
  noticePeriod
) => {
  const selectedTest = tests.find((test) => test.name === testType);
  console.log("Notice Period: ", noticePeriod);
  const payload = {
    testID: selectedTest.id,
    scheduledDateTime: scheduledDate.toISOString(),
    isMandatory: isMandatory,
    noticePeriod: isMandatory ? (noticePeriod ? noticePeriod : 0) : 0,
  };
  const url = editId
    ? `${Cloud_API_URL}/scheduled_tests/${userId}/scheduled-tests/${editId}`
    : `${Cloud_API_URL}/scheduled_tests/${userId}/scheduled-tests`;

  const method = editId ? "PUT" : "POST";

  try {
    const response = await fetch(url, {
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      return true;
    } else {
      console.error("Error creating/updating test:", response.statusText);
      return false;
    }
  } catch (error) {
    console.error("Error creating/updating test:", error);
    return false;
  }
};
